import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class OpportunitySyncProfilesService {
  getOpportunitySyncProfiles(cancelToken = null) {
    return ApiService.get(`${Config.api.document.url}api/v1/opportunity-sync-profiles`, {
      cancelToken: cancelToken && cancelToken.token,
    }).then((response) => response.data);
  }
  searchAccount({ syncProfileId, searchQuery }) {
    return ApiService.get(
      `${Config.api.document.url}api/v1/opportunity-sync-profiles/${syncProfileId}/external-accounts/search?query=${searchQuery}`,
    ).then((response) => response.data);
  }
  addAccount({ syncProfileId, name }) {
    return ApiService.post(
      `${Config.api.document.url}api/v1/opportunity-sync-profiles/${syncProfileId}/external-accounts/create`,
      { name },
    ).then((response) => response.data);
  }
  searchOpportunities({ syncProfileId, searchQuery }) {
    return ApiService.get(
      `${Config.api.document.url}api/v1/opportunity-sync-profiles/${syncProfileId}/external-opportunities/search?query=${searchQuery}`,
    ).then((response) => response.data);
  }
  getAllContacts({ syncProfileId, accountId, cancelToken = null }) {
    const query = new URLSearchParams();
    if (accountId != null) query.append('accountId', accountId);
    const params = query.toString() ? `?${query}` : '';
    return ApiService.get(
      `${Config.api.document.url}api/v1/opportunity-sync-profiles/${syncProfileId}/external-contacts/search${params}`,
      { cancelToken: cancelToken && cancelToken.token },
    ).then((response) => response.data);
  }
  searchContact({ syncProfileId, accountId, searchQuery, cancelToken = null }) {
    const query = new URLSearchParams({ query: searchQuery });
    if (accountId != null) query.append('accountId', accountId);
    return ApiService.get(
      `${Config.api.document.url}api/v1/opportunity-sync-profiles/${syncProfileId}/external-contacts/search?${query}`,
      { cancelToken: cancelToken && cancelToken.token },
    ).then((response) => response.data);
  }
  addContact({ syncProfileId, externalAccountId, firstName, lastName, email, telephone }) {
    return ApiService.post(
      `${Config.api.document.url}api/v1/opportunity-sync-profiles/${syncProfileId}/external-contacts/create`,
      { syncProfileId, externalAccountId, firstName, lastName, email, telephone },
    ).then((response) => response.data);
  }
  searchUser({ syncProfileId, searchQuery }) {
    return ApiService.get(
      `${Config.api.document.url}api/v1/opportunity-sync-profiles/${syncProfileId}/external-users/search?query=${searchQuery}`,
    ).then((response) => response.data);
  }
  getFieldMappings({ syncProfileId, scope, formOnly = false }) {
    const query = new URLSearchParams();
    if (scope) query.append('scope', scope);
    if (formOnly) query.append('formOnly', 'true');
    const params = query.toString() ? `?${query.toString()}` : '';
    return ApiService.get(
      `${Config.api.document.url}api/v1/opportunity-sync-profiles/${syncProfileId}/field-mappings${params}`,
    ).then((response) => response.data);
  }
  getFieldMappingOptions({ syncProfileId, fieldId }) {
    return ApiService.get(
      `${Config.api.document.url}api/v1/opportunity-sync-profiles/${syncProfileId}/field-mappings/${fieldId}/options`,
    ).then((response) => response.data);
  }
  getValueExpressionSchema() {
    return ApiService.get(`${Config.api.document.url}api/v1/opportunity-sync-profiles/value-expression-schema`).then(
      (response) => response.data,
    );
  }
  previewValueExpression({ valueExpression, opportunityId }) {
    return ApiService.post(`${Config.api.document.url}api/v1/opportunity-sync-profiles/value-expression-preview`, {
      valueExpression,
      opportunityId,
    }).then((response) => response.data);
  }
  previewValueExpressionBatch({ opportunityId, valueExpressions }) {
    return ApiService.post(
      `${Config.api.document.url}api/v1/opportunity-sync-profiles/value-expression-preview-batch`,
      { opportunityId, valueExpressions },
    ).then((response) => response.data);
  }

  // --- Admin CRUD ---

  getSyncProfile(profileId) {
    return ApiService.get(`${Config.api.document.url}api/v1/opportunity-sync-profiles/${profileId}`).then(
      (response) => response.data,
    );
  }
  createSyncProfile(profile) {
    return ApiService.post(`${Config.api.document.url}api/v1/opportunity-sync-profiles`, profile).then(
      (response) => response.data,
    );
  }
  updateSyncProfile(profileId, profile) {
    return ApiService.put(`${Config.api.document.url}api/v1/opportunity-sync-profiles/${profileId}`, profile).then(
      (response) => response.data,
    );
  }
  deleteSyncProfile(profileId) {
    return ApiService.delete(`${Config.api.document.url}api/v1/opportunity-sync-profiles/${profileId}`).then(
      (response) => response.data,
    );
  }
  createFieldMapping(profileId, mapping) {
    return ApiService.post(
      `${Config.api.document.url}api/v1/opportunity-sync-profiles/${profileId}/field-mappings`,
      mapping,
    ).then((response) => response.data);
  }
  updateFieldMapping(profileId, mappingId, mapping) {
    return ApiService.put(
      `${Config.api.document.url}api/v1/opportunity-sync-profiles/${profileId}/field-mappings/${mappingId}`,
      mapping,
    ).then((response) => response.data);
  }
  deleteFieldMapping(profileId, mappingId) {
    return ApiService.delete(
      `${Config.api.document.url}api/v1/opportunity-sync-profiles/${profileId}/field-mappings/${mappingId}`,
    ).then((response) => response.data);
  }
}

export const opportunitySyncProfilesService = new OpportunitySyncProfilesService();
